export const SHOP_ITEMS = [
  // --- PROJECTS ---
  {
    id: 'gen_ai_1',
    title: 'Gen AI Project 1',
    subtitle: 'Multichange Detection Agent',
    cost: 20,
    category: 'Project',
    openLink: 'https://topmate.io/datasense/page/USbLcBJZYG',
    lockedLink: 'https://topmate.io/datasense/1867027?coupon_code=DSGENAI1-9SS0X'
  },
  {
    id: 'gen_ai_2',
    title: 'Gen AI Project 2',
    subtitle: 'Amazon Competitor Analysis',
    cost: 20,
    category: 'Project',
    openLink: 'https://topmate.io/datasense/page/rEDL0CuVvn',
    lockedLink: 'https://topmate.io/datasense/1888390?coupon_code=DSGENAI2-C65VF'
  },
  {
    id: 'gen_ai_3',
    title: 'Gen AI Project 3',
    subtitle: 'MongoDB MCP Agent',
    cost: 30,
    category: 'Project',
    openLink: 'https://topmate.io/datasense/page/37CiRQLxg1',
    lockedLink: 'https://topmate.io/datasense/1872840?coupon_code=DSGENAI3-89A56'
  },
  {
    id: 'gen_ai_4',
    title: 'Gen AI Project 4',
    subtitle: 'Agent Guardian',
    cost: 30,
    category: 'Project',
    openLink: 'https://topmate.io/datasense/page/zNAO2DWFgZ',
    lockedLink: 'https://topmate.io/datasense/1875243?coupon_code=DSGENAI4-F0DS2'
  },
  {
    id: 'sql_proj_1',
    title: 'SQL Project 1',
    subtitle: 'Fraud Detection using Triggers',
    cost: 50,
    category: 'Project',
    openLink: 'https://topmate.io/datasense/page/cNXYOlKtlP',
    lockedLink: 'https://topmate.io/datasense/1864780?coupon_code=DSSQL1-2D186'
  },
  {
    id: 'github_1',
    title: 'DevOps Module',
    subtitle: 'GitHub & GitHub Actions',
    cost: 20,
    category: 'Project',
    openLink: 'https://topmate.io/datasense/page/UsbOcXJaY7',
    lockedLink: 'https://topmate.io/datasense/1876939?coupon_code=DSGITFULL-2DZ19'
  },

  // --- CORE COURSES ---
  {
    id: 'core_sql',
    title: 'SQL Heist',
    subtitle: 'Complete SQL Course',
    cost: 100,
    category: 'Course',
    openLink: 'https://topmate.io/datasense/page/5al4Lzj4cU',
    lockedLink: 'https://topmate.io/datasense/1809137?coupon_code=DSSQLFULL-AF29D',
    highlight: true
  },
  {
    id: 'core_python',
    title: 'Python Mastery',
    subtitle: 'Full Python Course',
    cost: 500,
    category: 'Course',
    openLink: 'https://topmate.io/datasense/page/oYsgtu7sUB',
    lockedLink: 'https://topmate.io/datasense/1726168?coupon_code=DSPYTHONFULL-Q5A9T',
    highlight: true
  },
  {
    id: 'core_genai',
    title: 'Gen AI LaunchPad',
    subtitle: 'From Zero to Hero',
    cost: 1000,
    category: 'Course',
    openLink: 'https://topmate.io/datasense/page/ul1DouEEg5',
    lockedLink: 'https://topmate.io/datasense/1726139?coupon_code=DSGENAIFULL-8X2L9',
    highlight: true
  },
];